
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"none","fill-rule":"evenodd"}},[_c('path',{attrs:{"d":"M0 0h24v24H0z"}}),_c('path',{attrs:{"fill":"#464646","d":"M16.754 12.611H6.803a2.437 2.437 0 01-2.358 1.833 2.444 2.444 0 110-4.888 2.44 2.44 0 012.358 1.833h9.95l.016-.049L6.18 5.165a2.444 2.444 0 11.709-1.72c0 .23-.041.448-.101.66l10.588 6.175a2.445 2.445 0 111.736 4.164c-.68 0-1.294-.277-1.736-.724L6.788 19.896c.06.211.101.43.101.66a2.445 2.445 0 11-.709-1.72L16.77 12.66l-.015-.049"}})])])
          )
        }
      }
    